import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-interface",
  "use": "icon-interface-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-interface\"><path d=\"M939.8 441.2V84.8c0-37-46.4-74.5-94.5-72.2H178.6c-54.8 0-96.6 33-94.4 72.2l11 358.5H12l0.9 283.1L226.8 869v142.6h570.4V869l213.9-142.6 0.9-283.2h-83.4l11.2-2z m-142.6 0h-71.3V227.3H583.3v213.9H440.7V227.3H298.1v213.9h-71.3V156l576.8-18.5v264l-6.4 39.7z\" p-id=\"18008\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol